
import firebase from 'firebase'
import 'firebase/firestore'
import firebaseConfig from './firebaseConfig'
const firebaseApp = firebase.initializeApp(firebaseConfig)
const firestore = firebaseApp.firestore()
const settings = {}
firestore.settings(settings)
// let usersRef = firestore.ref('user')
export default firestore